import { TrackingLabels } from "../types/Tracking";
import { type DataContainer, tracking } from "@otto-ec/tracking-bct";

class Tracking {
  static convertLabelsToDataContainer(labels: Partial<TrackingLabels>): DataContainer {
    const dataContainer: DataContainer = {};

    Object.keys(labels).forEach((key) => {
      const value = labels[key as keyof TrackingLabels];
      if (value !== undefined) {
        dataContainer[key] = Array.isArray(value) ? value : [value];
      }
    });

    return dataContainer;
  }

  submitEvent(labels: Partial<TrackingLabels>): void {
    tracking.submitEvent(Tracking.convertLabelsToDataContainer(labels));
  }

  submitAction(labels: Partial<TrackingLabels>, action: object): void {
    /*                                                         */
    /*         */
    tracking.submitEvent(Tracking.convertLabelsToDataContainer(labels), action);
  }
}

export default new Tracking();
